import { BehaviorSubject, Subject } from 'rxjs';
export var SidebarStatus;
(function (SidebarStatus) {
    SidebarStatus[SidebarStatus["OPEN"] = 0] = "OPEN";
    SidebarStatus[SidebarStatus["OPENING"] = 1] = "OPENING";
    SidebarStatus[SidebarStatus["CLOSE"] = 2] = "CLOSE";
    SidebarStatus[SidebarStatus["CLOSING"] = 3] = "CLOSING";
})(SidebarStatus || (SidebarStatus = {}));
;
// @Injectable({
//   providedIn: 'root'
// })
export class UiService {
    constructor() {
        this.sidebarStatus = SidebarStatus.CLOSE;
        this.showSidebar = new BehaviorSubject(false);
        this.title = new BehaviorSubject('');
        this.notificationsSubject = new Subject();
        this.notifications = this.notificationsSubject.asObservable();
    }
    setTitle(title) {
        this.title.next(title);
    }
    notifySuccess(content) {
        this.notificationsSubject.next({
            type: 'success',
            icon: 'check',
            content
        });
    }
    notifyWarning(content) {
        this.notificationsSubject.next({
            type: 'warning',
            icon: 'exclamation-triangle',
            content
        });
    }
    notifyError(content) {
        this.notificationsSubject.next({
            type: 'error',
            icon: 'skull-crossbones',
            content
        });
    }
    openSidebar() {
        if (this.sidebarStatus == SidebarStatus.OPEN || this.sidebarStatus == SidebarStatus.OPENING) {
            return;
        }
        this.sidebarStatus = SidebarStatus.OPENING;
        this.showSidebar.next(true);
    }
    closeSidebar() {
        if (this.sidebarStatus == SidebarStatus.CLOSE || this.sidebarStatus == SidebarStatus.CLOSING) {
            return;
        }
        this.sidebarStatus = SidebarStatus.CLOSING;
        this.showSidebar.next(false);
    }
    toggleSidebar() {
        if (this.sidebarStatus == SidebarStatus.OPEN || this.sidebarStatus == SidebarStatus.OPENING) {
            this.closeSidebar();
        }
        else {
            this.openSidebar();
        }
    }
}
